export default "__VITE_ASSET__DTaQ$HJe__"